import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import { has } from "../../../../utils/menu-context";
// import { callLicenseStatus } from "../../license/license.section";

export const callPaymentStatus = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "PAYMENT_STATUS", value: searchQuery });

export const callPrintStatus = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "PRINT_STATUS", value: searchQuery });

export const callRequestType = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "REQUEST_TYPE", value: searchQuery })

export const callProvince = () =>
    store
        .dispatch("resource/v1/master/province/cacheFindAll")

export const callReceiverDepartment = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/department/cacheFindAllReceiverDepartment", { searchQuery });

export const callLicenseRequestStatus = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "LICENSE_REQUEST_STATUS", value: searchQuery })

export const callLicenseRequestAttachment = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "LICENSE_REQUEST_ATTACHMENT", value: searchQuery, options: { sort: [{ name: "key", type: "asc" }] } });

export const callAddressType = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "ADDRESS_TYPE", value: searchQuery });

export const callOfficerUser = ({ searchQuery }) =>
    store.dispatch("resource/v1/security/user/cacheFindAllOfficerUser", { searchQuery })

export const createColumns = ({ data, props }) => {
    const { menuContext } = props;
    const columns = [
        createColumnInput({ title: () => i18n.global.t("model.licenseRequest.draftCode"), dataIndex: "draftCode", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.licenseRequest.requestCode"), dataIndex: "requestCode", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.licenseRequest.licenseCode"), dataIndex: "licenseCode", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.vessel.code"), dataIndex: "refVesselRequest.code", align: "center" }),
        createColumnSelect({
            visible: () =>  has({ menuContext, key: "canActionAssignMe" }),
            title: () => i18n.global.t("model.licenseRequest.bookLicenseRequests"),
            dataIndex: "bookLicenseRequests",
            customRender: ({ record }) => <div>{ record.bookLicenseRequests.find(bookData => bookData.refStatus.id == record.refStatus.id)?.refBookedBy?.fullNameTh }</div>,
            inputProp: ({ field }) => {
                return {
                    list: ({ searchQuery }) => callOfficerUser({ searchQuery }),
                    optLabel: "fullNameTh",
                    'onUpdate:value': (value) => {
                        field.searchValue = value
                        data.searchBookBy = value;
                    }
                }
            },
            search: {
                name: "bookLicenseRequests.refBookedBy.fullNameTh",
                field: {
                    searchValue: data.searchBookBy,
                    visible: () => has({ menuContext, key: "canActionAssignMe" })
                }
            }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.licenseRequest.requester"),
            dataIndex: "requesterName",
            align: "center"
        }),
        createColumnDate({ title: () => i18n.global.t("model.licenseRequest.requestDate"), dataIndex: "requestDate", align: "center"}),
        createColumnSelect({
            title: () => i18n.global.t("model.licenseRequest.refReceiveDept"),
            dataIndex: "refReceiveDept.nameTh",
            inputProp: () => ({ list: callReceiverDepartment, optLabel: "nameTh" }),
            search: { name: "refReceiveDept.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.licenseRequest.refRequestType"),
            dataIndex: "refRequestType.value",
            inputProp: () => ({ list: callRequestType, optLabel: "value" }),
            search: { name: "refRequestType.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.licenseRequest.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callLicenseRequestStatus, optLabel: "value" }),
            search: { name: "refStatus.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.licenseRequest.refPaymentStatus"),
            dataIndex: "refPaymentStatus.value",
            inputProp: () => ({ list: callPaymentStatus, optLabel: "value" }),
            search: { name: "refPaymentStatus.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.licenseRequest.refPrintStatus"),
            dataIndex: "refPrintStatus.value",
            inputProp: () => ({ list: callPrintStatus, optLabel: "value" }),
            search: { name: "refPrintStatus.id" }
        }),
      /*  createColumnSelect({
            title: () => i18n.global.t("model.licenseRequest.refLicenseStatus"),
            dataIndex: "refLicenseStatus.value",
            inputProp: () => ({ list: callLicenseStatus, optLabel: "value" }),
            search: { name: "refLicenseStatus.id" }
        }),*/

    ];
    return columns;
};